import * as React from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ExceptionHandler from './components/exception/exceptionHandle'
import NoPage from "./pages/noPage";
import AuthGuard from "./guards/AuthGuard";
import UnAuthGuard from "./guards/UnAuthGuard";
import GuestResponse from "./pages/unAuthGuests/guestResponse";
import { ChakraProvider } from '@chakra-ui/react';
import Login from './pages/login';
import Logout from './pages/logout';
import Home from './pages/home';
import Guests from './pages/authAdmin/guests';
import DisposableCameraPage from './pages/unAuthGuests/dispoCam';
import AdminRsvp from './pages/authAdmin/rsvp';
import AdminDispocam from './pages/authAdmin/adminDispoCam';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider>
    <ExceptionHandler>
      <BrowserRouter>
        <Routes>
          <Route key="Login" path="/login" element={
            <UnAuthGuard component={<Login />} />} >
          </Route>
          <Route key="Home" path="/" element={<AuthGuard component={
            <Home />} />} >
          </Route>
          <Route key="AdminDispoCam" path="/admin/dispocam" element={<AuthGuard component={
            <AdminDispocam />} />} >
          </Route>

          <Route key="EventGuests" path="/event/guests/rsvp" element={<AuthGuard component={
            <AdminRsvp />} />} >
          </Route>
          <Route key="EventGuests" path="/event/guests" element={<AuthGuard component={
            <Guests />} />} >
          </Route>
          <Route key="UnauthGuestResp" path="/guest/respond" element={
            <UnAuthGuard component={<GuestResponse />} />} >
          </Route>
          <Route key="GuestDispoCam" path="/guest/dispocam" element={
            <UnAuthGuard component={<DisposableCameraPage />} />} >
          </Route>
          <Route key="Login" path="/login" element={
            <UnAuthGuard component={<Login />} />} >
          </Route>
          <Route key="Logout" path="/logout" element={
            <UnAuthGuard component={<Logout />} />} >
          </Route>
          <Route path="*" element={<NoPage />} >
          </Route>
        </Routes>
      </BrowserRouter>
    </ExceptionHandler>
  </ChakraProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
